import { useCallback, useEffect, useState } from "react";
import { ScrollMore } from "../../ScrollMore";
import { useFeedStore } from "@/common/store/useFeedStore";
import { useAppStore } from "@/common/store/appStore";
import "./ScrollHint.scss";

interface IScrollHint {
  position: number;
  progress: number;
}

const PROGRESS_THRESHOLD = 2000;

export const ScrollHint = ({ position, progress }: IScrollHint) => {
  const setV2HeaderVisible = useFeedStore((state) => state.setV2HeaderVisible);
  const subredditName = useFeedStore((state) => state.subredditName);
  const isScrollHintVisible = useFeedStore((state) => state.isScrollHintVisible);
  const setScrollHintVisible = useFeedStore((state) => state.setScrollHintVisible);
  const [hasPassedThreshold, setHasPassedThreshold] = useState<boolean>(false);

  const isAnyMenuOpen = useAppStore((state) =>
    state.isSearchBarOpen || state.isProfileMenuOpen || state.isBurgerMenuOpen
  );

  useEffect(() => {
    if (!hasPassedThreshold) {
      return;
    }

    setV2HeaderVisible(isAnyMenuOpen || !isScrollHintVisible);

    return () => setV2HeaderVisible(true);
  }, [isAnyMenuOpen, isScrollHintVisible, hasPassedThreshold]);

  const onClose = useCallback(() => {
    setV2HeaderVisible(true);
    setScrollHintVisible(false);
  }, []);

  useEffect(() => {
    if (position > 1) {
      onClose();
    }
  }, [position, onClose]);

  useEffect(() => {
    if (progress > PROGRESS_THRESHOLD) {
      setHasPassedThreshold(true);
    }
  }, [progress]);

  if (!isScrollHintVisible || !hasPassedThreshold) {
    return null;
  }

  return <ScrollMore onClose={onClose} subredditName={subredditName} />;
};
